export default function (accumulator: number, a: number) {
  return accumulator + a;
}
